import { createRoot } from 'react-dom/client';
import { Snackbar, Alert } from '@mui/material';
import { useEffect, useState } from 'react';

let root;
let container;
const queue = [];

const SnackbarHost = () => {
  const [state, setState] = useState({
    open: false,
    message: '',
    severity: 'info',
    vertical: 'top',
    horizontal: 'right'
  });

  useEffect(() => {
    window.__openSnackbar = (message, severity = 'info', vertical = 'top', horizontal = 'right') => {
      setState({
        open: true,
        message,
        severity,
        vertical,
        horizontal
      });
    };

    if (queue.length) {
      const { message, severity } = queue.shift();
      window.__openSnackbar(message, severity);
    }

    return () => {
      delete window.__openSnackbar;
    };
  }, []);

  const handleClose = () => {
    setState(prev => ({ ...prev, open: false }));
  };

  return (
    <Snackbar
      open={state.open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: state.vertical, horizontal: state.horizontal }}
    >
      <Alert severity={state.severity} variant="filled" onClose={handleClose}>
        {state.message}
      </Alert>
    </Snackbar>
  );
};

const mountSnackbar = () => {
  if (root) return;

  container = document.createElement('div');
  document.body.appendChild(container);
  root = createRoot(container);
  root.render(<SnackbarHost />);
};

export const openSnackbarMain = (message, severity = 'info') => {
  if (window.__openSnackbar) {
    window.__openSnackbar(message, severity);
    return;
  }

  queue.push({ message, severity });

  if (!root) {
    mountSnackbar();
  }
};
